import React from "react";

// import apexChart

import Amchartfunnel from "../AllCharts/amchart/Funnelchart";
import XYChart from "../AllCharts/amchart/Xychart";
import PiechartAM from "../AllCharts/amchart/PiechartAM";
// import StackedBarChartAM from "../AllCharts/amchart/Stackbarwithnegativevalue";

import { Card, CardBody, CardTitle, Col, Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";


const ApexCharts = () => {
  document.title = "Linc Quality Hub";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Charts" breadcrumbItem="AMCharts" />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Line Chart</CardTitle>
                  <XYChart />
                </CardBody>
              </Card>
            </Col>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Funnel Chart Demo</CardTitle>
                  <Amchartfunnel />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Pie Chart</CardTitle>
                  <PiechartAM />
                </CardBody>
              </Card>
            </Col>
            {/* <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Stack Chart</CardTitle>
                  <StackedBarChartAM />
                </CardBody>
              </Card>
            </Col> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ApexCharts;
